document.addEventListener('DOMContentLoaded', () => {

    function updateVariantInURL(variantId) {
        const url = new URL(window.location);
        url.searchParams.set("variant", variantId);
        window.history.pushState({}, '', url);
        console.log("URL updated with variant:", url.toString());
    }

    function syncVariantToForm(variantId) {
        const formInputs = document.querySelectorAll('.form-id-input');
        formInputs.forEach(input => {
            input.value = variantId;
        });
    }

    const labels = document.querySelector('.BallTypeWrapperContainer').querySelectorAll(".radio-button-container");
    const urlParams = new URLSearchParams(window.location.search);
    const variantFromURL = urlParams.get("variant");

    if (variantFromURL) {
        labels.forEach(label => {
            const variantId = label.getAttribute("data-variant-id");
            const input = label.querySelector('input[type="radio"]');

            if (variantId === variantFromURL) {
                label.classList.add("active");
                input.checked = true;
                syncVariantToForm(variantId);
            } else {
                label.classList.remove("active");
                input.checked = false;
            }
        });
    } else {
        const activeLabel = document.querySelector('.BallTypeWrapperContainer').querySelector(".radio-button-container");
        if (activeLabel) {
            activeLabel.classList.add("active");
            const input = activeLabel.querySelector('input[type="radio"]');
            if (input) input.checked = true;

            const variantId = activeLabel.getAttribute("data-variant-id");
            updateVariantInURL(variantId);
            syncVariantToForm(variantId);
        }
    }


    labels.forEach(label => {
        label.addEventListener("click", () => {
            labels.forEach(l => {
                l.classList.remove("active");
                const input = l.querySelector('input[type="radio"]');
                if (input) input.checked = false;
            });

            label.classList.add("active");
            const input = label.querySelector('input[type="radio"]');
            if (input) input.checked = true;

            const variantId = label.getAttribute("data-variant-id");
            updateVariantInURL(variantId);
            syncVariantToForm(variantId);
        });
    });


    const quantityContainers = document.querySelectorAll(".BuildItemQuantity");
    const addToCartFormBuildBundle = document.querySelector('.add-to-cart-form');
    const addToCartMobileFormBuildBundle = document.querySelector('.add-to-cart-form-mobile');

    const rangefinderCheckboxes = document.querySelectorAll('.RangefinderCheckbox');

    const radioContainers = document.querySelector('.BallTypeWrapperContainer').querySelectorAll('.radio-button-container');
    if (radioContainers) {
        radioContainers.forEach(container => {
            container.addEventListener('click', function () {
                radioContainers.forEach(item => item.classList.remove('active'));

                this.classList.add('active');

                //const free_product_id = this.getAttribute('data-variant-id');
                const variantID = this.getAttribute('data-variant-id');
                const formVariantIDInput = document.querySelectorAll('.form-id-input');

                formVariantIDInput.forEach(node => {
                    node.value = variantID;
                });

                /*clearExistingInputs(addToCartFormBuildBundle);
                clearExistingInputs(addToCartMobileFormBuildBundle);

                addInputsToForm(addToCartFormBuildBundle, free_product_id);
                addInputsToForm(addToCartMobileFormBuildBundle, free_product_id);*/
            });
        });
    }

    quantityContainers.forEach(container => {
        const decreaseButton = container.querySelector(".QuantityButton#decrease");
        const increaseButton = container.querySelector(".QuantityButton#increase");
        const quantityValue = container.querySelector(".QuantityValue");
        const minusIcon = decreaseButton.querySelector("g");

        let quantity = 0;

        decreaseButton.addEventListener("click", function () {
            if (quantity > 0) {
                quantity--;
                quantityValue.textContent = quantity;

                if (quantity === 0) {
                    decreaseButton.disabled = true;
                    minusIcon.setAttribute("opacity", "0.4");

                    updatePricesAndCart();
                }
            }
            updatePricesAndCart();
        });

        increaseButton.addEventListener("click", function () {
            quantity++;
            quantityValue.textContent = quantity;
            if (quantity > 0) {
                decreaseButton.disabled = false;
                minusIcon.setAttribute("opacity", "1");

                const selectedVariant = document.querySelector('.SelectedText').getAttribute("data-selected-variant-id");
                if (selectedVariant) {
                    updatePricesAndCart();
                }
            }
            updatePricesAndCart();
        });
    });

    const stickyProductPriceElement = document.querySelector('.sticky-product-price');

    const mobileAddToCartButton = document.querySelector('.add-to-bag-mobile');
    const stickyProductTitle = document.querySelector('.sticky-product-title');

    let basePrice = 0;
    let baseProductTitle = '';

    if (stickyProductPriceElement) {
        const basePriceData = stickyProductPriceElement.getAttribute('data-base-price');
        if (basePriceData) {
            basePrice = parseFloat(basePriceData.replace(/[^0-9.-]+/g, "")) || 0;
        } else {
            basePrice = 0;
        }
    }


    if (stickyProductTitle) {
        baseProductTitle = stickyProductTitle.textContent.trim();
    }

    function formatPrice(amount) {
        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);
    }

    function updatePricesAndCart() {
        let bundleTotal = 0;
        let selectedItems = [];
        const selectedVariant = document.querySelector('.BuildYourBundleContainer .SelectedText').getAttribute("data-selected-variant-id");
        const existingInputs = addToCartFormBuildBundle.querySelectorAll('.ProProductInput');
        existingInputs.forEach(input => input.remove());

        let currentIndex = 3;

        const buildYourBundleItems = [];

        document.querySelectorAll(".BuildYourBundleItemContainer").forEach((container) => {
            container.addEventListener("click", function () {
                updatePricesAndCart();
            });
            const elem = container.querySelector('.radio-button-container');
            const productId = elem.getAttribute("data-product-id");
            const variantId = elem.getAttribute("data-variant-id");
            const price = elem.getAttribute("data-product-price");
            const title = elem.getAttribute("data-product-title");
            buildYourBundleItems.push({
                productId,
                variantId,
                price,
                title
            });
        })

        const item = buildYourBundleItems.find(bundleItem => bundleItem.variantId == selectedVariant);
        if (item) {
            const priceStr = item.price || "0";
            const price = parseFloat(priceStr.replace(/[^0-9.-]+/g, "")) || 0;

            const quantityContainer = document.querySelector('.BuildYourBundleContainer').querySelector(".BuildItemQuantity");
            const quantityValue = quantityContainer.querySelector(".QuantityValue");

            let quantity = parseInt(quantityValue.textContent);

            bundleTotal += price * quantity;

            let inputNode = document.createElement('input');
            inputNode.setAttribute('type', 'hidden');
            inputNode.setAttribute('name', `items[${currentIndex}][id]`);
            inputNode.setAttribute('value', item.variantId);
            inputNode.setAttribute('class', 'ProProductInput');
            addToCartFormBuildBundle.appendChild(inputNode);

            let inputNodeQuantity = document.createElement('input');
            inputNodeQuantity.setAttribute('type', 'hidden');
            inputNodeQuantity.setAttribute('name', `items[${currentIndex}][quantity]`);
            inputNodeQuantity.setAttribute('value', quantity);
            inputNodeQuantity.setAttribute('class', 'ProProductInput');
            addToCartFormBuildBundle.appendChild(inputNodeQuantity);

            currentIndex++;

            selectedItems.push({
                title: item.title,
                price: price,
                quantity: quantity
            });
        }

        const totalPrice = basePrice + bundleTotal;

        if (stickyProductPriceElement) {
            stickyProductPriceElement.textContent = formatPrice(totalPrice);
        }

        if (stickyProductTitle) {
            let newTitle = baseProductTitle;

            if (selectedItems.length > 0) {
                const selectedProductTitles = selectedItems.map(item => `${item.title}`).join(' + ');
                newTitle += ' + ' + selectedProductTitles;
            }

            stickyProductTitle.textContent = newTitle;
        }

        if (addToCartMobileFormBuildBundle) {
            const mobileExistingInputs = addToCartMobileFormBuildBundle.querySelectorAll('.ProProductInput');
            mobileExistingInputs.forEach(input => input.remove());

            let mobileCurrentIndex = 3;

            const item = buildYourBundleItems.find(bundleItem => bundleItem.variantId == selectedVariant);
            if (item) {
                const priceStr = item.price || "0";
                const price = parseFloat(priceStr.replace(/[^0-9.-]+/g, "")) || 0;

                const quantityContainer = document.querySelector('.BuildYourBundleContainer').querySelector(".BuildItemQuantity");
                const quantityValue = quantityContainer.querySelector(".QuantityValue");
                let quantity = parseInt(quantityValue.textContent);

                let inputNode = document.createElement('input');
                inputNode.setAttribute('type', 'hidden');
                inputNode.setAttribute('name', `items[${mobileCurrentIndex}][id]`);
                inputNode.setAttribute('value', item.variantId);
                inputNode.setAttribute('class', 'ProProductInput');
                addToCartMobileFormBuildBundle.appendChild(inputNode);

                let inputNodeQuantity = document.createElement('input');
                inputNodeQuantity.setAttribute('type', 'hidden');
                inputNodeQuantity.setAttribute('name', `items[${mobileCurrentIndex}][quantity]`);
                inputNodeQuantity.setAttribute('value', quantity);
                inputNodeQuantity.setAttribute('class', 'ProProductInput');
                addToCartMobileFormBuildBundle.appendChild(inputNodeQuantity);

                mobileCurrentIndex++;
            }

            rangefinderCheckboxes.forEach((rangefinderCheckbox) => {
                if (rangefinderCheckbox.checked) {
                    let inputNode = document.createElement('input');
                    inputNode.type = 'hidden';
                    inputNode.name = `items[${mobileCurrentIndex}][id]`;
                    inputNode.value = rangefinderCheckbox.dataset.id;
                    inputNode.className = 'ProProductInput';
                    addToCartMobileFormBuildBundle.appendChild(inputNode);

                    let qtyNode = document.createElement('input');
                    qtyNode.type = 'hidden';
                    qtyNode.name = `items[${mobileCurrentIndex}][quantity]`;
                    qtyNode.value = 1;
                    qtyNode.className = 'ProProductInput';
                    addToCartMobileFormBuildBundle.appendChild(qtyNode);

                    mobileCurrentIndex++;
                }
            });
        }

        if (mobileAddToCartButton) {
            const baseText = mobileAddToCartButton.getAttribute('data-base-text') || 'ADD TO CART - ';
            mobileAddToCartButton.textContent = `${baseText}${formatPrice(totalPrice)}`;
        }
    }
    if (buildYourBundleItems.length > 0) {

        // if (checkboxes.length > 0 && stickyProductPriceElement && addToCartFormBuildBundle) {

        //     checkboxes.forEach((checkbox) => {
        //         checkbox.addEventListener('change', function () {
        //             const parentElement = this.closest('.BuildYourBundleItemContainer');

        //             if (parentElement) {
        //                 parentElement.classList.toggle(
        //                     'active',
        //                     this.checked
        //                 );
        //             }

        //             updatePricesAndCart();
        //         });
        //     });

        //     rangefinderCheckboxes.forEach((checkbox) => {
        //         checkbox.addEventListener('change', function () {
        //             const card = this.closest('.RangefinderCard');

        //             if (card) {
        //                 card.classList.toggle(
        //                     'active',
        //                     this.checked
        //                 );
        //             }

        //             updatePricesAndCart();
        //         });
        //     });

        //     updatePricesAndCart();
        // }
    }

});